export default {"src":"/_next/static/media/Myorders.01ac26f8.svg","height":38,"width":39,"blurWidth":0,"blurHeight":0};